import React from 'react';

import { Flex, HStack, Text } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';

import { Button, Icon, StatusBadge } from 'components';
import { breadcrumbs } from 'constants/routes';
import BreadcrumbMenu from 'containers/Breadcrumb';
import { useFormModal } from 'hooks/useFormModal';

interface MetaProps {
    data: any
    isEditable?: boolean
    refetch: () => void
    onEdit?: () => void
    fallbackContent?: string
    label?: string
    statusKey?: string
}

export default function Meta({
  data, refetch, fallbackContent, onEdit, isEditable = true, label, statusKey = 'status',
}:MetaProps) {
  const { id, content = fallbackContent } = useParams<GeneralRoute>();
  const { onOpen, setUpdateId, Form } = useFormModal(content);

  if (!data) {
    return null;
  }

  return (
    <>
      <BreadcrumbMenu paths={[
        ...breadcrumbs[content] || [],
        {
          path: `/${content}/${id}`,
          label: label ?? data.name,
        },
      ]}
      />
      <Flex
        align="center"
        justify="space-between">
        <Form onSuccess={refetch} />
        <Flex
          align="center"
          mt={2}>
          <Text
            whiteSpace="nowrap"
            textOverflow="ellipsis"
            overflow="hidden"
            variant="3xLargeBold"
            color="gray.700">{label ?? data?.name}
          </Text>
          {data[statusKey] && (
          <StatusBadge
            label={data[statusKey].toLocaleUpperCase()}
            ml={5}
            h="22px"
            status={data[statusKey]}
          />
          )}
        </Flex>
        <HStack hidden={!isEditable}>
          <Button
            onClick={() => {
              if (onEdit) {
                onEdit();
              } else {
                setUpdateId(data.id);
                onOpen();
              }
            }}
            _hover={{
              bg: 'primary.700',
              color: 'white.default',
            }}
            bg="white.default"
            borderRadius={50}
            h={8}
            _active={{
              color: 'white.default',
            }}
            color="gray.500">
            <Text variant="xSmallSemiBold">Editar</Text><Icon
              ml={2}
              name="edit"
            />
          </Button>
        </HStack>
      </Flex>
    </>
  );
}
